import React from "react";
import { Box, Input, Typography } from "@mui/material";
import { PropertyGroup } from "../PropertyGroup";
import { East } from "@mui/icons-material";
import { usePathContext } from "../PathInfo";
import { useTreeModifyContext } from "../TreeDataContext";

export function DirectionEditor(props: { dir: number }) {
  const { path } = usePathContext();
  const { saveChangesAtPath } = useTreeModifyContext();

  function fromRadToDeg(rad: number) {
    return (rad * 180) / Math.PI;
  }

  function fromDegToRad(deg: number) {
    return (deg * Math.PI) / 180;
  }

  return (
    <PropertyGroup>
      <Box className="horizontal-flex">
        <Typography>Direction:&nbsp;</Typography>
        <Input
          type="number"
          size="small"
          id="direction"
          value={fromRadToDeg(props.dir)}
          onChange={(event) => {
            saveChangesAtPath(fromDegToRad(parseInt(event.target.value)), path.concat(["multiDirection"]));
          }}
          slotProps={{ input: { type: "number", min: 0, max: 359, step: 1 } }}
        />
        <East style={{ rotate: `${props.dir}rad` }} />
      </Box>
    </PropertyGroup>
  );
}
